import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import '../../App.css';
import GreenGreyLightIcon from '../../components/GreenGreyLightIcon';
import RedGreyLightIcon from '../../components/RedGreyLightIcon';
import { Styles, StyleConstants } from '../../Styles';

const CarDoorSystemTab = (props) => {
    const { packet } = props;

    return (
        <>
            {(packet.board1 !== null) && (
                <TableContainer component={Paper}>
                    <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                        <TableHead>
                            <TableRow sx={{ '& th': { color: '#FFFFFF', backgroundColor: StyleConstants.mainBgColor } }}>
                                <TableCell sx={{ ...Styles.carCell }}>
                                    Door System
                                </TableCell>
                                <TableCell sx={{ ...Styles.carBorderCell, width: '230px' }}>
                                    Door 1
                                </TableCell>
                                <TableCell sx={{ ...Styles.carBorderCell, width: '230px' }}>
                                    Door 2
                                </TableCell>
                                <TableCell sx={{ ...Styles.carBorderCell, width: '230px' }}>
                                    Door 3
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={{ ...Styles.carCell }}>
                                    Door Lock Status
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={packet.board1.door1.doorClosedAndLocked} onLabel="Door Locked" offLabel="Door Unlocked" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={packet.board1.door2.doorClosedAndLocked} onLabel="Door Locked" offLabel="Door Unlocked" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={packet.board1.door3.doorClosedAndLocked} onLabel="Door Locked" offLabel="Door Unlocked" />
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={{ ...Styles.carCell }}>
                                    Door Open / Close Status
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door1.doorFullyOpen} onLabel="Fully Opened" offLabel="Door Closed" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door2.doorFullyOpen} onLabel="Fully Opened" offLabel="Door Closed" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door3.doorFullyOpen} onLabel="Fully Opened" offLabel="Door Closed" />
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={{ ...Styles.carCell }}>
                                    Door Emergency Device Status
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door1.doorEmerDeviceAct} onLabel="Door Emergency Activated" offLabel="Normal" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door2.doorEmerDeviceAct} onLabel="Door Emergency Activated" offLabel="Normal" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door3.doorEmerDeviceAct} onLabel="Door Emergency Activated" offLabel="Normal" />
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={{ ...Styles.carCell }}>
                                    Door Obstruction Status
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door1.doorObsDetected} onLabel="Door Obstruction Detected" offLabel="Not Detected" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door2.doorObsDetected} onLabel="Door Obstruction Detected" offLabel="Not Detected" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <RedGreyLightIcon onOffBit={packet.board1.door3.doorObsDetected} onLabel="Door Obstruction Detected" offLabel="Not Detected" />
                                </TableCell>
                            </TableRow>
                            <TableRow sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                                <TableCell sx={{ ...Styles.carCell }}>
                                    Checkback Zero Speed
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={packet.board1.door1.checkbackZeroSpeed} onLabel="Zero Speed" offLabel="Non-Zero" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={packet.board1.door2.checkbackZeroSpeed} onLabel="Zero Speed" offLabel="Non-Zero" />
                                </TableCell>
                                <TableCell sx={Styles.carBorderCell}>
                                    <GreenGreyLightIcon onOffBit={packet.board1.door3.checkbackZeroSpeed} onLabel="Zero Speed" offLabel="Non-Zero" />
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
};

export default CarDoorSystemTab;